import { useCallback, useEffect, useState } from "react";

export const CHAT_DEBUG_STORAGE_KEY = "lypro.chat.debugMessages";

export function useDebugMessagesPreference() {
  const [showDebugMessages, setShowDebugMessages] = useState<boolean>(() => {
    if (typeof window === "undefined") {
      return false;
    }

    const storedValue = window.localStorage.getItem(CHAT_DEBUG_STORAGE_KEY);
    return storedValue === "true";
  });

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    window.localStorage.setItem(
      CHAT_DEBUG_STORAGE_KEY,
      showDebugMessages ? "true" : "false"
    );
  }, [showDebugMessages]);

  const toggleDebugMessages = useCallback(() => {
    setShowDebugMessages((current) => !current);
  }, []);

  return {
    showDebugMessages,
    setShowDebugMessages,
    toggleDebugMessages,
  };
}
